/* The Interiors Studio — elevation engine and state (2026-09-14).
   Draws a fitted wardrobe as an architectural elevation from the customer's dimensions, bay by bay,
   dressed with real door fronts and finishes. Reads its option data from a JSON block the section
   renders (metaobjects when present). Nothing here is priced. */
(function () {
  'use strict';
  var root = document.querySelector('[data-yi-studio-app]');
  if (!root) return;
  var DATA = (function () { try { return JSON.parse(root.querySelector('[data-yi-studio-data]').textContent); } catch (e) { return null; } })();
  if (!DATA) return;
  var KEY = 'yi-studio-design';
  var LIMITS = { w: [1200, 6000], h: [2000, 2700], d: [400, 700] };
  var BAY = { min: 450, max: 1000, ideal: 900 };
  var PLINTH = 100, TOP = 60, SIDE = 18, DOORGAP = 4;
  var byId = function (list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; };
  function bySort(a, b) { return (a.sort || 0) - (b.sort || 0); }
  ['components', 'doors', 'finishes', 'handles'].forEach(function (k) { (DATA[k] || []).sort(bySort); });
  var comps = DATA.components, doors = DATA.doors, finishes = DATA.finishes, handles = DATA.handles;
  function firstId(list, pref, filter) { var p = pref && byId(list, pref); if (p && (!filter || filter(p))) return p.id; var f = list.filter(filter || function () { return true; })[0]; return f ? f.id : ''; }

  /* ——— analytics on the house channel ——— */
  function track(name, attrs) {
    var payload = Object.assign({ event: name, room: 'interiors-studio' }, attrs || {});
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('yi:analytics', { detail: payload })); } catch (e) {}
  }

  /* ——— state ——— */
  function defaultBays(w) {
    var n = Math.max(1, Math.round(w / BAY.ideal));
    while (w / n > BAY.max) n++;
    while (n > 1 && w / n < BAY.min) n--;
    var each = Math.round(w / n);
    var arr = [];
    for (var i = 0; i < n; i++) arr.push({ w: each, comps: {} });
    arr[n - 1].w = w - each * (n - 1);
    return arr;
  }
  function starter(bays) {
    var key = S.spaceKey || 'fitted-wardrobe';
    var pattern = key === 'home-office'
      ? [{ 'desk-fitted': 1, 'cupboard-above': 1, 'drawer-std': 3 }, { 'shelf-adj': 4, 'drawer-std': 2 }, { 'desk-fitted': 1, 'shelf-open': 2 }]
      : [{ 'hang-double': 1 }, { 'shelf-adj': 3, 'drawer-std': 3 }, { 'hang-long': 1 }, { 'shelf-adj': 4, 'shoe-shelf': 2 }];
    bays.forEach(function (b, i) { b.comps = JSON.parse(JSON.stringify(pattern[i % pattern.length])); });
    return bays;
  }
  var S = {
    space: root.getAttribute('data-yi-space') || 'Fitted wardrobe',
    w: 3800, h: 2400, d: 600,
    opening: 'hinged', door: firstId(doors, 'narrow-frame-shaker', function (d) { return d.opening === 'hinged'; }),
    finishExt: firstId(finishes, 'paint-porcelain', function (f) { return f.applies !== 'interior'; }),
    finishInt: firstId(finishes, 'int-white', function (f) { return f.applies === 'interior'; }),
    handle: firstId(handles, 'hw-brushed-brass'), lighting: [], bays: null, sel: 0, view: 'exterior', notes: '', step: 0, saved: false
  };
  S.spaceKey = (location.hash.match(/space=([a-z-]+)/) || [])[1] || 'fitted-wardrobe';
  S.bays = starter(defaultBays(S.w));
  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || sessionStorage.getItem(KEY) || 'null');
      if (s && s.bays) { Object.keys(s).forEach(function (k) { S[k] = s[k]; }); S.saved = !!localStorage.getItem(KEY); }
    } catch (e) {}
  }
  function persist(toLocal) {
    try { var j = JSON.stringify(S); sessionStorage.setItem(KEY, j); if (toLocal) { localStorage.setItem(KEY, j); S.saved = true; } } catch (e) {}
  }
  load();
  var urlSpace = (location.hash.match(/space=([a-z-]+)/) || [])[1];
  if (urlSpace && DATA.spaces && DATA.spaces[urlSpace]) { if (S.spaceKey !== urlSpace) { S.spaceKey = urlSpace; S.bays = starter(defaultBays(S.w)); S.sel = 0; } S.space = DATA.spaces[urlSpace].name; if (DATA.spaces[urlSpace].opening) S.opening = DATA.spaces[urlSpace].opening; }

  function reconcileDoor() {
    var d = byId(doors, S.door);
    if (S.opening === 'sliding' && (!d || d.opening !== 'sliding')) S.door = firstId(doors, 'sliding-panels', function (x) { return x.opening === 'sliding'; });
    if (S.opening === 'hinged' && (!d || d.opening !== 'hinged')) S.door = firstId(doors, 'narrow-frame-shaker', function (x) { return x.opening === 'hinged'; });
  }
  reconcileDoor();
  /* ——— geometry ——— */
  function rebalanceBays() {
    var n = S.bays.length; var each = Math.round(S.w / n);
    S.bays.forEach(function (b) { b.w = each; });
    S.bays[n - 1].w = S.w - each * (n - 1);
  }
  function splitBay(i) {
    var b = S.bays[i]; if (b.w / 2 < BAY.min) return false;
    var nb = { w: Math.round(b.w / 2), comps: JSON.parse(JSON.stringify(b.comps)) };
    b.w = b.w - nb.w; S.bays.splice(i + 1, 0, nb); return true;
  }
  function mergeBay(i) {
    if (S.bays.length < 2) return false;
    var j = i < S.bays.length - 1 ? i + 1 : i - 1;
    var keep = S.bays[Math.min(i, j)], gone = S.bays[Math.max(i, j)];
    if (keep.w + gone.w > BAY.max) return false;
    keep.w += gone.w; S.bays.splice(Math.max(i, j), 1); S.sel = Math.min(i, j); return true;
  }

  /* ——— drawing ——— */
  var svgNS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs, children) {
    var e = document.createElementNS(svgNS, tag);
    Object.keys(attrs || {}).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    (children || []).forEach(function (c) { if (c) e.appendChild(c); });
    return e;
  }
  function text(x, y, str, cls, anchor) { var t = el('text', { x: x, y: y, 'class': cls || 'lab', 'text-anchor': anchor || 'middle' }); t.textContent = str; return t; }
  var INK = '#2b1e1a', LINE = '#6f6253', SOFT = '#9c8f80', BRASS = '#8f6f3f', CARCASS = '#ece7de';
  function finishOf(id) { return byId(finishes, id); }
  function fillFor(f, defs, key) {
    if (!f) return CARCASS;
    if (f.rgb) return 'rgb(' + f.rgb + ')';
    if (f.img) {
      var pid = 'p-' + key + '-' + f.id.replace(/[^a-z0-9]/gi, '');
      if (!defs.querySelector('#' + pid)) {
        var p = el('pattern', { id: pid, patternUnits: 'userSpaceOnUse', width: 600, height: 600 });
        p.appendChild(el('image', { href: f.img, width: 600, height: 600, preserveAspectRatio: 'xMidYMid slice' }));
        defs.appendChild(p);
      }
      return 'url(#' + pid + ')';
    }
    return CARCASS;
  }
  function handleColour() { var h = byId(handles, S.handle); return h && h.rgb ? 'rgb(' + h.rgb + ')' : BRASS; }

  function drawComponents(g, x, y, w, h, bay) {
    /* zones: top items stack down from the top, bottom items stack up from the plinth, middle fills between */
    var items = [];
    Object.keys(bay.comps).forEach(function (id) { var c = byId(comps, id); if (c && bay.comps[id] > 0) items.push({ c: c, n: bay.comps[id] }); });
    var topY = y + 20, botY = y + h - 20, inner = w - 24, ix = x + 12;
    var lit = S.lighting.length > 0;
    var desk = items.filter(function (i) { return i.c.zone === 'desk'; })[0];
    var worktopY = null, pedestal = false;
    if (desk) {
      worktopY = y + h + PLINTH - 730;
      // worktop: 40 mm thick, full bay width, drawn with a front edge
      g.appendChild(el('rect', { x: x + 2, y: worktopY - 40, width: w - 4, height: 40, fill: '#d9cfc0', stroke: INK, 'stroke-width': 5 }));
      if (desk.c.key === 'desk-floating') { g.appendChild(el('line', { x1: x + 60, y1: worktopY, x2: x + 60, y2: worktopY + 30, stroke: SOFT, 'stroke-width': 3 })); }
      else { g.appendChild(el('line', { x1: x + 30, y1: worktopY, x2: x + 30, y2: y + h, stroke: LINE, 'stroke-width': 8 })); }
      // wall items above the desk
      items.filter(function (i) { return i.c.zone === 'desk-wall'; }).forEach(function (i) {
        if (i.c.key === 'monitor') { var mw = Math.min(700, inner - 80), mh = Math.round(mw * 0.58); g.appendChild(el('rect', { x: ix + (inner - mw) / 2, y: worktopY - 140 - mh, width: mw, height: mh, fill: '#e6e1d8', stroke: LINE, 'stroke-width': 5 })); g.appendChild(el('line', { x1: ix + inner / 2, y1: worktopY - 140, x2: ix + inner / 2, y2: worktopY - 40, stroke: LINE, 'stroke-width': 8 })); }
        if (i.c.key === 'socket') { for (var q = 0; q < 2; q++) g.appendChild(el('rect', { x: ix + inner - 200 + q * 90, y: worktopY - 130, width: 70, height: 70, fill: 'none', stroke: SOFT, 'stroke-width': 4 })); }
      });
      botY = worktopY - 500; pedestal = true;
    }
    // top: shelves (fixed/adjustable/open) and a top shelf
    items.filter(function (i) { return i.c.zone === 'top'; }).forEach(function (i) {
      for (var k = 0; k < i.n; k++) {
        var sy = topY + (i.c.h || 300);
        if (sy > botY - 200) break;
        if (i.c.key === 'cupboard') {
          g.appendChild(el('rect', { x: ix + 2, y: topY + 2, width: inner - 4, height: sy - topY - 4, fill: '#e3ddd2', stroke: INK, 'stroke-width': 5 }));
          if (inner > 600) g.appendChild(el('line', { x1: ix + inner / 2, y1: topY + 2, x2: ix + inner / 2, y2: sy - 2, stroke: INK, 'stroke-width': 4 }));
          g.appendChild(el('line', { x1: ix + inner / 2 - 60, y1: sy - 60, x2: ix + inner / 2 + 60, y2: sy - 60, stroke: handleColour(), 'stroke-width': 8 }));
          topY = sy; continue;
        }
        g.appendChild(el('line', { x1: ix, y1: sy, x2: ix + inner, y2: sy, stroke: LINE, 'stroke-width': 10 }));
        if (lit && S.lighting.indexOf('light-shelf') !== -1) g.appendChild(el('line', { x1: ix + 8, y1: sy + 9, x2: ix + inner - 8, y2: sy + 9, stroke: BRASS, 'stroke-width': 3, opacity: .9 }));
        topY = sy;
      }
    });
    // bottom: drawers, shoe storage, baskets
    var pedX = ix, pedW = inner, pedBot = botY;
    if (pedestal) { pedW = Math.round(inner * 0.45); pedX = ix + inner - pedW; pedBot = worktopY - 40; }
    items.filter(function (i) { return i.c.zone === 'bottom'; }).sort(function (a, b) { return (a.c.sort || 0) - (b.c.sort || 0); }).forEach(function (i) {
      for (var k = 0; k < i.n; k++) {
        var hh = i.c.h || 180; var dy = pedBot - hh;
        if (pedestal ? (dy < y + h - 700) : (dy < topY + 200)) break;
        var ix0 = ix, inner0 = inner; if (pedestal) { ix = pedX; inner = pedW; }
        if (i.c.key === 'drawer') {
          g.appendChild(el('rect', { x: ix + 4, y: dy + 4, width: inner - 8, height: hh - 8, fill: '#e3ddd2', stroke: LINE, 'stroke-width': 6 }));
          g.appendChild(el('line', { x1: ix + inner / 2 - 60, y1: dy + hh / 2, x2: ix + inner / 2 + 60, y2: dy + hh / 2, stroke: handleColour(), 'stroke-width': 8 }));
        } else if (i.c.key === 'drawer-glass') {
          g.appendChild(el('rect', { x: ix + 4, y: dy + 4, width: inner - 8, height: hh - 8, fill: 'rgba(200,215,225,.35)', stroke: LINE, 'stroke-width': 6 }));
          g.appendChild(el('line', { x1: ix + 14, y1: dy + hh - 26, x2: ix + inner - 14, y2: dy + hh - 26, stroke: SOFT, 'stroke-width': 3 }));
        } else if (i.c.key === 'shoe') {
          g.appendChild(el('line', { x1: ix, y1: dy + hh, x2: ix + inner, y2: dy + hh - 60, stroke: LINE, 'stroke-width': 8 }));
          for (var s = 0; s < Math.max(2, Math.floor(inner / 220)); s++) g.appendChild(el('ellipse', { cx: ix + 110 + s * 220, cy: dy + hh - 30 - s * 0, rx: 70, ry: 26, fill: 'none', stroke: SOFT, 'stroke-width': 4 }));
        } else if (i.c.key === 'shoe-pullout') {
          g.appendChild(el('rect', { x: ix + 4, y: dy + 4, width: inner - 8, height: hh - 8, fill: 'none', stroke: LINE, 'stroke-width': 6, 'stroke-dasharray': '24 14' }));
          g.appendChild(el('line', { x1: ix + 20, y1: dy + hh - 40, x2: ix + inner - 20, y2: dy + hh - 40, stroke: SOFT, 'stroke-width': 4 }));
        } else if (i.c.key === 'basket') {
          g.appendChild(el('rect', { x: ix + 30, y: dy + 10, width: inner - 60, height: hh - 20, fill: 'none', stroke: LINE, 'stroke-width': 6 }));
          for (var v = 0; v < 4; v++) g.appendChild(el('line', { x1: ix + 30, y1: dy + 40 + v * 50, x2: ix + inner - 30, y2: dy + 40 + v * 50, stroke: SOFT, 'stroke-width': 3 }));
        } else {
          g.appendChild(el('rect', { x: ix + 4, y: dy + 4, width: inner - 8, height: hh - 8, fill: 'none', stroke: LINE, 'stroke-width': 6 }));
        }
        if (pedestal) { pedBot = dy; ix = ix0; inner = inner0; } else { botY = dy; }
      }
    });
    // middle: hanging and side accessories
    var midH = botY - topY;
    var mids = items.filter(function (i) { return i.c.zone === 'middle'; });
    var railW = inner;
    var sides = items.filter(function (i) { return i.c.zone === 'side'; });
    if (sides.length && inner > 500) { railW = inner - 150; }
    mids.forEach(function (i) {
      var k = i.c.key;
      function rail(yy, w2) { g.appendChild(el('line', { x1: ix, y1: yy, x2: ix + w2, y2: yy, stroke: INK, 'stroke-width': 7 })); g.appendChild(el('circle', { cx: ix + 40, cy: yy + 40, r: 9, fill: 'none', stroke: SOFT, 'stroke-width': 3 })); g.appendChild(el('circle', { cx: ix + w2 - 40, cy: yy + 40, r: 9, fill: 'none', stroke: SOFT, 'stroke-width': 3 })); }
      if (k === 'hang-single') rail(topY + 90, railW);
      else if (k === 'hang-double') { rail(topY + 90, railW); if (midH > 1200) rail(topY + Math.round(midH / 2) + 40, railW); }
      else if (k === 'hang-long') { rail(topY + 90, railW); g.appendChild(el('line', { x1: ix + railW / 2, y1: topY + 110, x2: ix + railW / 2, y2: botY - 60, stroke: SOFT, 'stroke-width': 2, 'stroke-dasharray': '10 16' })); }
      else if (k === 'hang-pulldown') { rail(topY + 90, railW); g.appendChild(el('path', { d: 'M' + (ix + 30) + ' ' + (topY + 90) + ' q 40 220 ' + (railW / 2 - 30) + ' 320', fill: 'none', stroke: SOFT, 'stroke-width': 3 })); g.appendChild(el('path', { d: 'M' + (ix + railW - 30) + ' ' + (topY + 90) + ' q -40 220 -' + (railW / 2 - 30) + ' 320', fill: 'none', stroke: SOFT, 'stroke-width': 3 })); }
      else if (k === 'trouser') { for (var t = 0; t < 5; t++) g.appendChild(el('line', { x1: ix + 40 + t * ((railW - 80) / 4), y1: topY + 130, x2: ix + 40 + t * ((railW - 80) / 4), y2: topY + 600, stroke: SOFT, 'stroke-width': 3 })); rail(topY + 90, railW); }
    });
    sides.forEach(function (i, idx) {
      var sx = ix + inner - 120;
      var sy = topY + 120 + idx * 160;
      g.appendChild(el('rect', { x: sx, y: sy, width: 100, height: 120, fill: 'none', stroke: LINE, 'stroke-width': 5 }));
      for (var q = 0; q < 3; q++) g.appendChild(el('line', { x1: sx + 12, y1: sy + 30 + q * 30, x2: sx + 88, y2: sy + 30 + q * 30, stroke: SOFT, 'stroke-width': 3 }));
    });
    if (lit && S.lighting.indexOf('light-led') !== -1) g.appendChild(el('line', { x1: ix + 8, y1: y + 12, x2: ix + inner - 8, y2: y + 12, stroke: BRASS, 'stroke-width': 4 }));
    if (lit && S.lighting.indexOf('light-sensor') !== -1) g.appendChild(el('circle', { cx: ix + inner - 30, cy: y + 34, r: 10, fill: BRASS, opacity: .85 }));
  }

  function drawDoors(g, x, y, w, h, defs) {
    var door = byId(doors, S.door) || {};
    var f = finishOf(S.finishExt);
    var fill = fillFor(f, defs, 'ext');
    var key = door.key || 'slab';
    function leaf(lx, lw) {
      g.appendChild(el('rect', { x: lx, y: y, width: lw, height: h, fill: fill, stroke: INK, 'stroke-width': 5 }));
      g.appendChild(el('rect', { x: lx + 6, y: y + 6, width: lw - 12, height: h - 12, fill: 'none', stroke: 'rgba(255,255,255,.18)', 'stroke-width': 3 }));
      if (key === 'shaker' || key === 'shaker-narrow' || key === 'shaker-textured') {
        var fr = key === 'shaker-narrow' ? 60 : 90;
        g.appendChild(el('rect', { x: lx + fr, y: y + fr, width: lw - 2 * fr, height: h - 2 * fr, fill: 'none', stroke: 'rgba(43,30,26,.45)', 'stroke-width': 4 }));
        g.appendChild(el('rect', { x: lx + fr + 12, y: y + fr + 12, width: lw - 2 * fr - 24, height: h - 2 * fr - 24, fill: 'rgba(0,0,0,.05)', stroke: 'none' }));
      } else if (key === 'beaded' || key === 'beaded-panel') {
        g.appendChild(el('rect', { x: lx + 90, y: y + 90, width: lw - 180, height: h - 180, fill: 'none', stroke: 'rgba(43,30,26,.45)', 'stroke-width': 4 }));
        g.appendChild(el('rect', { x: lx + 112, y: y + 112, width: lw - 224, height: h - 224, fill: 'rgba(0,0,0,.05)', stroke: 'rgba(43,30,26,.35)', 'stroke-width': 3 }));
      } else if (key === 'integrated') {
        g.appendChild(el('rect', { x: lx + 40, y: y + 60, width: lw - 80, height: 34, fill: 'rgba(0,0,0,.18)' }));
      } else if (key === 'vgroove') {
        for (var v = 1; v < 4; v++) g.appendChild(el('line', { x1: lx + (lw / 4) * v, y1: y + 12, x2: lx + (lw / 4) * v, y2: y + h - 12, stroke: 'rgba(43,30,26,.25)', 'stroke-width': 3 }));
      }
      var hs = byId(handles, S.handle) || {};
      if (hs.kind !== 'none' && key !== 'integrated') {
        var hy = y + Math.min(h * 0.5, 1000);
        g.appendChild(el('line', { x1: lx + lw - 70, y1: hy - 70, x2: lx + lw - 70, y2: hy + 70, stroke: handleColour(), 'stroke-width': 9, 'stroke-linecap': 'round' }));
      }
    }
    var anyDesk = S.bays.some(function (b) { return Object.keys(b.comps).some(function (id) { var c = byId(comps, id); return c && c.zone === 'desk'; }); });
    if (S.opening === 'sliding' && !anyDesk) {
      var panels = Math.max(2, Math.round(w / 1000));
      var pw = Math.round((w + (panels - 1) * 40) / panels);
      for (var p = 0; p < panels; p++) {
        var px = x + p * (pw - 40);
        g.appendChild(el('rect', { x: px, y: y, width: pw, height: h, fill: fill, stroke: INK, 'stroke-width': 6 }));
        if (p > 0) g.appendChild(el('rect', { x: px - 6, y: y, width: 26, height: h, fill: 'rgba(20,14,10,.35)' }));
        g.appendChild(el('rect', { x: px + 22, y: y + 22, width: pw - 44, height: h - 44, fill: 'none', stroke: 'rgba(255,255,255,.35)', 'stroke-width': 4 }));
        g.appendChild(el('rect', { x: px + 22, y: y + 22, width: pw - 44, height: h - 44, fill: 'none', stroke: 'rgba(20,14,10,.35)', 'stroke-width': 2 }));
      }
      g.appendChild(el('line', { x1: x, y1: y + 2, x2: x + w, y2: y + 2, stroke: INK, 'stroke-width': 10 }));
      return;
    }
    var cx = x;
    S.bays.forEach(function (b) {
      var bw = b.w;
      var hasDesk = Object.keys(b.comps).some(function (id) { var c = byId(comps, id); return c && c.zone === 'desk'; });
      if (hasDesk) { cx += bw; return; }
      if (bw > 620) { var half = Math.round((bw - DOORGAP) / 2); leaf(cx + DOORGAP / 2, half - DOORGAP); leaf(cx + half + DOORGAP / 2, bw - half - DOORGAP); }
      else leaf(cx + DOORGAP / 2, bw - DOORGAP);
      cx += bw;
    });
  }

  var stage = root.querySelector('[data-yi-stage]');
  function draw() {
    var W = S.w + SIDE * 2, H = S.h;
    var mL = 260, mR = 120, mT = 90, mB = 150;
    var svg = el('svg', { viewBox: '0 0 ' + (W + mL + mR) + ' ' + (H + mT + mB), role: 'img', 'aria-label': 'Elevation of your ' + S.space.toLowerCase() + ', ' + S.w + ' by ' + S.h + ' millimetres, ' + S.bays.length + ' bays' });
    var defs = el('defs'); svg.appendChild(defs);
    var style = el('style'); style.textContent = '.lab{font:52px "Source Sans 3",Arial,sans-serif;fill:#6f6253;letter-spacing:.08em}.lab.k{fill:#2b1e1a}.dim{stroke:#9c8f80;stroke-width:3}'; svg.appendChild(style);
    var ox = mL, oy = mT;
    // floor line + wall
    svg.appendChild(el('line', { x1: ox - 200, y1: oy + H, x2: ox + W + 100, y2: oy + H, stroke: '#c9c0b3', 'stroke-width': 4 }));
    // carcass
    var intFill = fillFor(finishOf(S.finishInt), defs, 'int');
    svg.appendChild(el('rect', { x: ox, y: oy, width: W, height: H - PLINTH, fill: intFill, stroke: INK, 'stroke-width': 7 }));
    svg.appendChild(el('rect', { x: ox + 30, y: oy + H - PLINTH, width: W - 60, height: PLINTH, fill: '#d8d1c5', stroke: INK, 'stroke-width': 5 }));
    // top box
    svg.appendChild(el('line', { x1: ox, y1: oy + TOP, x2: ox + W, y2: oy + TOP, stroke: INK, 'stroke-width': 4 }));
    var bayG = el('g', { 'class': 'bays' });
    var cx = ox + SIDE;
    S.bays.forEach(function (b, i) {
      var g = el('g', { 'class': 'bay' + (i === S.sel ? ' is-sel' : ''), tabindex: '0', role: 'button', 'aria-pressed': i === S.sel ? 'true' : 'false', 'aria-label': 'Bay ' + (i + 1) + ', ' + b.w + ' millimetres wide. ' + bayLabel(b) + '. Select to edit', 'data-bay': i });
      g.appendChild(el('rect', { 'class': 'selfill', x: cx, y: oy + TOP, width: b.w, height: H - PLINTH - TOP, fill: 'transparent' }));
      if (i > 0) svg.appendChild(el('line', { x1: cx, y1: oy + TOP, x2: cx, y2: oy + H - PLINTH, stroke: INK, 'stroke-width': 5 }));
      var deskBay = Object.keys(b.comps).some(function (id) { var c = byId(comps, id); return c && c.zone === 'desk'; });
      if (S.view === 'interior' || S.opening === 'open' || deskBay) drawComponents(g, cx, oy + TOP, b.w, H - PLINTH - TOP, b);
      g.appendChild(el('rect', { 'class': 'sel', x: cx + 4, y: oy + TOP + 4, width: b.w - 8, height: H - PLINTH - TOP - 8, fill: 'none', stroke: 'transparent', 'stroke-width': 3 }));
      var lab = text(cx + b.w / 2, oy + H + 70, 'BAY ' + (i < 9 ? '0' : '') + (i + 1) + ' · ' + b.w, 'lab' + (i === S.sel ? ' k' : ''));
      g.appendChild(lab);
      bayG.appendChild(g);
      cx += b.w;
    });
    if (S.view === 'exterior' && S.opening !== 'open') {
      var dG = el('g', { 'class': 'doors' });
      drawDoors(dG, ox + SIDE, oy + TOP + 6, W - SIDE * 2, H - PLINTH - TOP - 12, defs);
      svg.appendChild(dG);
      svg.appendChild(bayG); // invisible hit targets on top so bays can still be selected
      bayG.querySelectorAll('.selfill').forEach(function (r) { r.setAttribute('fill', 'transparent'); });
    } else { svg.appendChild(bayG); }
    // dimension lines
    svg.appendChild(el('line', { 'class': 'dim', x1: ox, y1: oy - 40, x2: ox + W, y2: oy - 40 }));
    svg.appendChild(el('line', { 'class': 'dim', x1: ox, y1: oy - 60, x2: ox, y2: oy - 20 }));
    svg.appendChild(el('line', { 'class': 'dim', x1: ox + W, y1: oy - 60, x2: ox + W, y2: oy - 20 }));
    svg.appendChild(text(ox + W / 2, oy - 56, S.w + ' mm', 'lab k'));
    svg.appendChild(el('line', { 'class': 'dim', x1: ox - 120, y1: oy, x2: ox - 120, y2: oy + H }));
    svg.appendChild(el('line', { 'class': 'dim', x1: ox - 140, y1: oy, x2: ox - 100, y2: oy }));
    svg.appendChild(el('line', { 'class': 'dim', x1: ox - 140, y1: oy + H, x2: ox - 100, y2: oy + H }));
    var vt = text(ox - 150, oy + H / 2, S.h + ' mm', 'lab k'); vt.setAttribute('transform', 'rotate(-90 ' + (ox - 150) + ' ' + (oy + H / 2) + ')'); svg.appendChild(vt);
    // depth strip (plan)
    var py = oy + H + 110;
    svg.appendChild(el('rect', { x: ox, y: py, width: W, height: Math.round(S.d / 12), fill: '#e3ddd2', stroke: SOFT, 'stroke-width': 3 }));
    svg.appendChild(text(ox + W + 40, py + Math.round(S.d / 24) + 18, S.d + ' mm deep', 'lab', 'start'));
    stage.innerHTML = '';
    stage.appendChild(svg);
  }
  function bayLabel(b) {
    var parts = [];
    Object.keys(b.comps).forEach(function (id) { var c = byId(comps, id); if (c && b.comps[id] > 0) parts.push((b.comps[id] > 1 ? b.comps[id] + ' × ' : '') + c.name); });
    return parts.length ? parts.join(', ') : 'Empty bay';
  }

  /* ——— rail: tabs and panels ——— */
  var tabs = [].slice.call(root.querySelectorAll('[data-yi-tab]'));
  var panels = [].slice.call(root.querySelectorAll('[data-yi-panel]'));
  var maxStep = 0;
  function showStep(i) {
    S.step = Math.max(0, Math.min(i, panels.length - 1)); maxStep = Math.max(maxStep, S.step);
    tabs.forEach(function (t, k) { t.classList.toggle('is-on', k === S.step); t.classList.toggle('is-done', k < maxStep && k !== S.step); t.setAttribute('aria-selected', k === S.step ? 'true' : 'false'); });
    panels.forEach(function (p, k) { p.classList.toggle('is-on', k === S.step); });
    var back = root.querySelector('[data-yi-back]'), next = root.querySelector('[data-yi-next]');
    back.hidden = S.step === 0; next.hidden = S.step === panels.length - 1;
    var wantView = panels[S.step].getAttribute('data-yi-view');
    if (wantView && wantView !== S.view) { S.view = wantView; syncView(); draw(); }
    if (window.innerWidth < 900) { var rail = root.querySelector('[data-yi-rail]'); rail.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    persist(false);
  }
  tabs.forEach(function (t, k) { t.addEventListener('click', function () { showStep(k); if (t.getAttribute('data-yi-tab') === 'finishes') loadLibrary(); }); });
  root.querySelector('[data-yi-next]').addEventListener('click', function () { if (panels[Math.min(S.step + 1, panels.length - 1)] && tabs[Math.min(S.step + 1, panels.length - 1)].getAttribute('data-yi-tab') === 'finishes') loadLibrary(); });
  root.querySelector('[data-yi-next]').addEventListener('click', function () { showStep(S.step + 1); });
  root.querySelector('[data-yi-back]').addEventListener('click', function () { showStep(S.step - 1); });

  /* ——— view toggle ——— */
  function syncView() { [].slice.call(root.querySelectorAll('[data-yi-view-btn]')).forEach(function (b) { var on = b.getAttribute('data-yi-view-btn') === S.view; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
  [].slice.call(root.querySelectorAll('[data-yi-view-btn]')).forEach(function (b) { b.addEventListener('click', function () { S.view = b.getAttribute('data-yi-view-btn'); syncView(); draw(); }); });

  /* ——— dimensions ——— */
  function clamp(v, lim) { v = parseInt(v, 10); if (isNaN(v)) return lim[0]; return Math.max(lim[0], Math.min(lim[1], Math.round(v / 10) * 10)); }
  [].slice.call(root.querySelectorAll('[data-yi-dim]')).forEach(function (inp) {
    var k = inp.getAttribute('data-yi-dim');
    inp.value = S[k];
    var range = root.querySelector('[data-yi-range="' + k + '"]'); if (range) range.value = S[k];
    function apply(v, final) {
      var nv = clamp(v, LIMITS[k]);
      if (final) inp.value = nv;
      if (range) range.value = nv;
      if (nv === S[k]) return;
      S[k] = nv;
      if (k === 'w') { var n = S.bays.length; var each = Math.round(S.w / n); if (each > BAY.max || each < BAY.min) { S.bays = starter(defaultBays(S.w)); S.sel = 0; } else rebalanceBays(); }
      draw(); summary(); persist(false);
      if (final) track('dimensions_entered', { width: S.w, height: S.h, depth: S.d });
    }
    inp.addEventListener('change', function () { apply(inp.value, true); });
    inp.addEventListener('input', function () { if (inp.value.length >= 4) apply(inp.value, false); });
    if (range) range.addEventListener('input', function () { inp.value = range.value; apply(range.value, false); });
    if (range) range.addEventListener('change', function () { apply(range.value, true); });
  });

  /* ——— the extended finish library, loaded once, when Finishes opens ——— */
  var libLoaded = false, libLoading = false;
  function loadLibrary() {
    if (libLoaded || libLoading) return; libLoading = true;
    var url = root.getAttribute('data-yi-library'); if (!url) return;
    var note = root.querySelector('[data-yi-library-note]'); if (note) note.hidden = false;
    fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
      var group = root.querySelector('[data-yi-choice="finishExt"]');
      (d.finishes || []).forEach(function (f) {
        if (byId(finishes, f.id)) return;
        finishes.push(f);
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-yi-val', f.id); b.setAttribute('aria-pressed', 'false'); b.title = f.name;
        b.innerHTML = '<i style="background-image:url(\'' + f.img + '\')"></i><span>' + esc(f.name) + '</span>';
        group.appendChild(b);
      });
      finishes.sort(bySort);
      libLoaded = true; if (note) note.hidden = true;
      paintChoices();
      var cur = byId(finishes, S.finishExt); if (cur) draw();
    }).catch(function () { if (note) note.textContent = 'The full finish library could not load. The finishes shown are the standard palette.'; });
  }
  /* ——— generic single/multi choice groups ——— */
  function paintChoices() {
    [].slice.call(root.querySelectorAll('[data-yi-choice]')).forEach(function (g) {
      var key = g.getAttribute('data-yi-choice'); var val = S[key];
      [].slice.call(g.querySelectorAll('button')).forEach(function (b) {
        var v = b.getAttribute('data-yi-val');
        var on = Array.isArray(val) ? val.indexOf(v) !== -1 : val === v;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    // doors that don't fit the opening are dimmed; handle choices hidden for integrated doors
    var door = byId(doors, S.door) || {};
    [].slice.call(root.querySelectorAll('[data-yi-choice="door"] button')).forEach(function (b) {
      var d = byId(doors, b.getAttribute('data-yi-val')) || {};
      var fits = S.opening === 'open' ? false : (S.opening === 'sliding' ? d.opening === 'sliding' : d.opening === 'hinged');
      b.disabled = !fits; b.style.opacity = fits ? '' : '.35';
    });
    var fam = S.opening === 'sliding' ? 'Sliding' : (door.family || '');
    var texturedDoor = door.key === 'slab' && /textured/i.test(door.name || '');
    [].slice.call(root.querySelectorAll('[data-yi-choice="finishExt"] button')).forEach(function (b) {
      var f = byId(finishes, b.getAttribute('data-yi-val')) || {}; var list = f.doors || [];
      var ok = !fam || !list.length || list.indexOf(fam) !== -1;
      if (texturedDoor) ok = f.family !== 'painted';
      else if (fam !== 'Sliding' && f.family !== 'painted' && !texturedDoor) ok = f.applies === 'textured' ? false : ok;
      b.hidden = !ok;
    });
    var cur = byId(finishes, S.finishExt); var curBtn = cur && root.querySelector('[data-yi-choice="finishExt"] button[data-yi-val="' + cur.id + '"]');
    if (!cur || (curBtn && curBtn.hidden)) { var firstVisible = [].slice.call(root.querySelectorAll('[data-yi-choice="finishExt"] button')).filter(function (b) { return !b.hidden; })[0]; if (firstVisible) { S.finishExt = firstVisible.getAttribute('data-yi-val'); [].slice.call(root.querySelectorAll('[data-yi-choice="finishExt"] button')).forEach(function (b) { var on = b.getAttribute('data-yi-val') === S.finishExt; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); } }
    var handleWrap = root.querySelector('[data-yi-handles]'); if (handleWrap) handleWrap.hidden = (door.key === 'integrated') || S.opening === 'open' || S.opening === 'sliding';
    var doorWrap = root.querySelector('[data-yi-doors]'); if (doorWrap) doorWrap.hidden = S.opening === 'open';
    var extWrap = root.querySelector('[data-yi-extfinish]'); if (extWrap) extWrap.hidden = S.opening === 'open';
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-yi-choice] button'); if (!b || !root.contains(b) || b.disabled) return;
    var g = b.closest('[data-yi-choice]'); var key = g.getAttribute('data-yi-choice'); var v = b.getAttribute('data-yi-val');
    if (g.hasAttribute('data-yi-multi')) { var arr = Array.isArray(S[key]) ? S[key].slice() : []; var i = arr.indexOf(v); if (i === -1) arr.push(v); else arr.splice(i, 1); S[key] = arr; }
    else { S[key] = v; }
    if (key === 'door' || (key === 'opening' && v === 'sliding')) { var dd = byId(doors, key === 'door' ? v : S.door) || {}; if (v === 'sliding' || /textured/i.test(dd.name || '')) loadLibrary(); }
    if (key === 'opening') {
      if (v === 'sliding') { var sd = doors.filter(function (d) { return d.opening === 'sliding'; })[0]; if (sd) S.door = sd.id; }
      if (v === 'hinged') { var hd = byId(doors, S.door); if (!hd || hd.opening !== 'hinged') S.door = (doors.filter(function (d) { return d.opening === 'hinged'; })[0] || {}).id; }
      S.view = v === 'open' ? 'interior' : 'exterior'; syncView();
    }
    var ev = { opening: 'doors_selected', door: 'door_style_selected', finishExt: 'finish_selected', finishInt: 'finish_selected', handle: 'hardware_selected', lighting: 'lighting_selected' }[key];
    if (ev) track(ev, { choice: v });
    paintChoices(); draw(); summary(); persist(false);
  });

  /* ——— bay editor ——— */
  var bayList = root.querySelector('[data-yi-baylist]');
  var compList = root.querySelector('[data-yi-complist]');
  function bayEditor() {
    bayList.innerHTML = '';
    S.bays.forEach(function (b, i) {
      var btn = document.createElement('button'); btn.type = 'button'; btn.textContent = 'Bay ' + (i < 9 ? '0' : '') + (i + 1);
      btn.className = i === S.sel ? 'is-on' : ''; btn.setAttribute('aria-pressed', i === S.sel ? 'true' : 'false');
      btn.addEventListener('click', function () { S.sel = i; draw(); bayEditor(); });
      bayList.appendChild(btn);
    });
    var b = S.bays[S.sel]; if (!b) return;
    root.querySelector('[data-yi-bayname]').textContent = 'Bay ' + (S.sel < 9 ? '0' : '') + (S.sel + 1) + ' · ' + b.w + ' mm wide';
    root.querySelector('[data-yi-split]').disabled = b.w / 2 < BAY.min;
    root.querySelector('[data-yi-merge]').disabled = S.bays.length < 2;
    compList.innerHTML = '';
    var cats = {};
    comps.forEach(function (c) { if (c.spaces && c.spaces.length && S.spaceKey && c.spaces.indexOf(S.spaceKey) === -1) return; (cats[c.category] = cats[c.category] || []).push(c); });
    Object.keys(cats).forEach(function (cat) {
      var h = document.createElement('div'); h.className = 'yi-st__sub'; h.innerHTML = '<span>' + cat + '</span>'; compList.appendChild(h);
      cats[cat].forEach(function (c) {
        var n = b.comps[c.id] || 0;
        var fits = (!c.minBay || b.w >= c.minBay) && (!c.maxBay || b.w <= c.maxBay);
        var row = document.createElement('div'); row.className = 'yi-st__comp' + (n ? ' is-on' : '');
        row.innerHTML = '<div><span class="nm">' + c.name + '</span><span class="ds">' + (fits ? (c.desc || '') : 'Needs a bay between ' + (c.minBay || BAY.min) + ' and ' + (c.maxBay || BAY.max) + ' mm') + '</span></div>' +
          '<span class="ctl"><button type="button" aria-label="Fewer ' + c.name + '"' + (n === 0 ? ' disabled' : '') + '>−</button><b aria-live="polite">' + n + '</b><button type="button" aria-label="More ' + c.name + '"' + (!fits || n >= (c.max || 1) ? ' disabled' : '') + '>+</button></span>';
        var btns = row.querySelectorAll('button');
        btns[0].addEventListener('click', function () { setComp(c, n - 1); });
        btns[1].addEventListener('click', function () { setComp(c, n + 1); });
        compList.appendChild(row);
      });
    });
  }
  function setComp(c, n) {
    var b = S.bays[S.sel]; n = Math.max(0, Math.min(n, c.max || 1));
    if (c.exclusive) { comps.forEach(function (o) { if (o.exclusive === c.exclusive && o.id !== c.id) delete b.comps[o.id]; }); }
    if (n === 0) delete b.comps[c.id]; else b.comps[c.id] = n;
    track(n ? 'storage_selected' : 'storage_removed', { component: c.id, bay: S.sel + 1 });
    draw(); bayEditor(); summary(); persist(false);
  }
  root.querySelector('[data-yi-split]').addEventListener('click', function () { if (splitBay(S.sel)) { track('module_added', { bays: S.bays.length }); draw(); bayEditor(); summary(); persist(false); } });
  root.querySelector('[data-yi-merge]').addEventListener('click', function () { if (mergeBay(S.sel)) { draw(); bayEditor(); summary(); persist(false); } });
  root.querySelector('[data-yi-copybay]').addEventListener('click', function () { var src = S.bays[S.sel]; S.bays.forEach(function (b) { if (b !== src) b.comps = JSON.parse(JSON.stringify(src.comps)); }); draw(); summary(); persist(false); });
  stage.addEventListener('click', function (e) { var g = e.target.closest('.bay'); if (!g) return; S.sel = parseInt(g.getAttribute('data-bay'), 10); draw(); bayEditor(); if (S.view === 'exterior' && S.opening !== 'open') { S.view = 'interior'; syncView(); draw(); } var storageTab = tabs.findIndex ? tabs.findIndex(function (t) { return t.getAttribute('data-yi-tab') === 'storage'; }) : 2; if (S.step !== storageTab) showStep(storageTab); });
  stage.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('bay')) { e.preventDefault(); e.target.dispatchEvent(new MouseEvent('click', { bubbles: true })); } });

  /* ——— summary and review ——— */
  function totals() {
    var t = {}; S.bays.forEach(function (b) { Object.keys(b.comps).forEach(function (id) { t[id] = (t[id] || 0) + b.comps[id]; }); });
    return Object.keys(t).map(function (id) { var c = byId(comps, id); return c ? { name: c.name, n: t[id], cat: c.category } : null; }).filter(Boolean);
  }
  function rows() {
    var door = byId(doors, S.door) || {}, fe = finishOf(S.finishExt) || {}, fi = finishOf(S.finishInt) || {}, hd = byId(handles, S.handle) || {};
    var r = [['Project', S.space], ['Dimensions', S.w + ' × ' + S.h + ' × ' + S.d + ' mm'], ['Bays', S.bays.length + ' (' + S.bays.map(function (b) { return b.w; }).join(' / ') + ' mm)'],
      ['Doors', S.opening === 'open' ? 'Open, no doors' : (S.opening === 'sliding' ? 'Sliding' : 'Hinged') + (door.name ? ' · ' + door.name : '')]];
    if (S.opening !== 'open') r.push(['Exterior', fe.name || '—']);
    r.push(['Interior', fi.name || '—']);
    if (S.opening !== 'open' && S.opening !== 'sliding' && door.key !== 'integrated') r.push(['Hardware', hd.name || '—']);
    var t = totals(); if (t.length) r.push(['Storage', t.map(function (x) { return x.name + (x.n > 1 ? ' × ' + x.n : ''); }).join(', ')]);
    var l = S.lighting.map(function (id) { var c = byId(DATA.lightingOptions, id); return c ? c.name : id; }); if (l.length) r.push(['Lighting', l.join(', ')]);
    if (S.notes) r.push(['Notes', S.notes]);
    return r;
  }
  function summary() {
    var html = rows().map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
    [].slice.call(root.querySelectorAll('[data-yi-summary-list]')).forEach(function (l) { l.innerHTML = html; });
    var bar = root.querySelector('[data-yi-bar-line]'); if (bar) bar.textContent = S.w + ' × ' + S.h + ' mm · ' + S.bays.length + ' bays';
    var per = root.querySelector('[data-yi-baysummary]'); if (per) per.innerHTML = S.bays.map(function (b, i) { return '<div><dt>Bay ' + (i < 9 ? '0' : '') + (i + 1) + '</dt><dd>' + esc(b.w + ' mm · ' + bayLabel(b)) + '</dd></div>'; }).join('');
    var savedEl = root.querySelector('[data-yi-saved]'); if (savedEl) savedEl.textContent = S.saved ? 'Saved in this browser' : '';
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function plain() { return rows().map(function (r) { return r[0] + ': ' + r[1]; }).concat(S.bays.map(function (b, i) { return 'Bay ' + (i + 1) + ' (' + b.w + ' mm): ' + bayLabel(b); })).join('\n'); }

  /* ——— save / email / reset ——— */
  root.querySelector('[data-yi-save]').addEventListener('click', function () { persist(true); summary(); track('design_saved', { bays: S.bays.length }); });
  var mail = root.querySelector('[data-yi-email]');
  if (mail) mail.addEventListener('click', function () { mail.setAttribute('href', 'mailto:?subject=' + encodeURIComponent('My Yorkshire Interiors design') + '&body=' + encodeURIComponent(plain() + '\n\nContinue at ' + location.href.split('#')[0])); });
  var reset = root.querySelector('[data-yi-reset]');
  if (reset) reset.addEventListener('click', function () { try { localStorage.removeItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {} location.reload(); });
  var notes = root.querySelector('[data-yi-notes]'); if (notes) { notes.value = S.notes || ''; notes.addEventListener('input', function () { S.notes = notes.value; summary(); persist(false); }); }
  var bar = root.querySelector('[data-yi-bar]'); var sum = root.querySelector('[data-yi-summary]');
  if (bar) bar.addEventListener('click', function () { var open = sum.classList.toggle('is-open'); bar.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  var closeSum = root.querySelector('[data-yi-summary-close]'); if (closeSum) closeSum.addEventListener('click', function () { sum.classList.remove('is-open'); });

  /* ——— quote: every selection becomes a labelled field ——— */
  var form = root.querySelector('form.yi-st__quote');
  if (form) {
    form.addEventListener('submit', function () {
      var holder = form.querySelector('[data-yi-hidden]'); holder.innerHTML = '';
      function add(n, v) { if (!v) return; var i = document.createElement('input'); i.type = 'hidden'; i.name = 'contact[' + n + ']'; i.value = v; holder.appendChild(i); }
      rows().forEach(function (r) { add(r[0], r[1]); });
      S.bays.forEach(function (b, i) { add('Bay ' + (i + 1) + ' (' + b.w + ' mm)', bayLabel(b)); });
      add('Design JSON', JSON.stringify({ space: S.space, w: S.w, h: S.h, d: S.d, opening: S.opening, door: S.door, finishExt: S.finishExt, finishInt: S.finishInt, handle: S.handle, lighting: S.lighting, bays: S.bays }));
      track('quote_submitted', { bays: S.bays.length, opening: S.opening });
    });
    var quoteTab = tabs.filter(function (t) { return t.getAttribute('data-yi-tab') === 'quote'; })[0];
    if (quoteTab) quoteTab.addEventListener('click', function () { track('quote_started', {}); });
  }
  if (root.querySelector('[data-yi-sent]')) { try { localStorage.removeItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {} }

  /* ——— boot ——— */
  S.spaceKey = urlSpace || S.spaceKey || 'fitted-wardrobe';
  root.querySelector('[data-yi-spacename]').textContent = S.space;
  syncView(); paintChoices(); draw(); bayEditor(); summary();
  showStep(S.step || 0);
  track('configurator_opened', { space: S.spaceKey });
  window.addEventListener('hashchange', function () { var m = (location.hash.match(/space=([a-z-]+)/) || [])[1]; if (m && DATA.spaces[m]) { var changed = S.spaceKey !== m; S.space = DATA.spaces[m].name; S.spaceKey = m; if (changed) { S.bays = starter(defaultBays(S.w)); S.sel = 0; bayEditor(); } if (DATA.spaces[m].opening) { S.opening = DATA.spaces[m].opening; S.view = S.opening === 'open' ? 'interior' : 'exterior'; } reconcileDoor(); root.querySelector('[data-yi-spacename]').textContent = S.space; syncView(); paintChoices(); draw(); summary(); persist(false); track('project_type_selected', { space: m }); } });
})();
